var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-subheader',{attrs:{"light":""}},[_vm._v(_vm._s(_vm.lastPostedLabel)+" "+_vm._s(_vm._f("format")(_vm.createdAt)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }